/* eslint-disable no-unused-vars */
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { Button } from 'reactstrap'
import SelectDate from './SelectDate'
import SelectEvent from './SelectEvent'
import SelectEventStatus from './SelectEventStatus'
import SelectPaymentStatus from './SelectPaymentStatus'

function SelectFilter({
  filter,
  listEventGroupIdByHost,
  onChangeEvent,
  onChangeEventStatus,
  onChangePaymentStatus,
  onChangeRangeDate,
  handleClearFilter,
  orderTab,
  isConsolidate
}) {
  const { listEvent, eventStatus, paymentStatus } = filter

  return (
    <>
      <div className='d-flex align-items-center'>
        <div style={{ maxWidth: '600px' }}>
          <SelectEvent
            listEvent={listEvent}
            onChangeEvent={onChangeEvent}
            listEventGroupIdByHost={listEventGroupIdByHost}
            isDisabled={isConsolidate}
          />
        </div>
        <div style={{ maxWidth: '400px', marginRight: '20px' }}>
          <SelectEventStatus
            onChangeEventStatus={onChangeEventStatus}
            eventStatus={eventStatus}
          />
        </div>
        {/* <SelectDate
          onChangeRangeDate={onChangeRangeDate}
        /> */}
        {!isConsolidate && (
          <SelectPaymentStatus
            onChangePaymentStatus={onChangePaymentStatus}
            paymentStatus={paymentStatus}
            isDisabled={orderTab === 'unpaid'}
          />
        )}
        <Button
          role='button'
          outline
          className='btn btn-date rounded-0 ms-3 shadow-none'
          onClick={handleClearFilter}
        >
          Clear Filter
        </Button>
      </div>
    </>
  )
}

export default SelectFilter
